﻿import React from 'react';
import PropTypes from 'prop-types';
import { ShowHide } from 'components/layout';
import { NavLink } from 'react-router-dom'
import classNames from 'classnames';

import 'components/navigation/Navigation.css';


export function VerticalExpanderGroup(
    {
        groups = [],
        selectedItem = 0,
        selectedGroup = 0,
        loading,
        onGroupSelect,
        onItemSelect
    }
) {
    return (
        <div className="bp6-tabs bp6-vertical">
            <ul className="bp6-tab-list" role="tablist">
                {groups.map((g, groupIndex) => {
                    return (
                        <li key={groupIndex} >
                            <div className={classNames("bp6-tab", { "bp6-skeleton": loading })} role="tab" aria-selected={selectedGroup === g.id && !loading} onClick={() => {
                                onGroupSelect(g.id)
                            }}
                            onKeyDown={(e) => { }}
                            >{g.title}</div>
                            <ShowHide
                                evaluator={selectedGroup === g.id && !loading}
                                show={(
                                    <div className="bp6-tab-child-menu">
                                        <ul>
                                            {g.children && g.children.map((l, childIndex) => {
                                                return (
                                                    <li key={childIndex} className={classNames({ "active": selectedItem === l.id })}><NavLink to={l.location} end onClick={() => {
                                                        onItemSelect(l.id)
                                                    }}>{l.title}</NavLink></li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            />

                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

VerticalExpanderGroup.propTypes = {
    groups: PropTypes.array,
    selectedItem: PropTypes.number,
    selectedGroup: PropTypes.number,
    onGroupSelect: PropTypes.func
};